import type { FineImportMember, FinePreviewRow } from './types.ts'
import { extractNameParts, rankMembers } from '../member-name-match.ts'

export { extractNameParts }

export function matchFineRow(
  row: FinePreviewRow,
  members: readonly FineImportMember[],
): FinePreviewRow {
  if (row.manuallyMatched) return row
  const candidates = rankMembers([row.sourceName], members, 0.6)
  const eligible = candidates.filter((candidate) => candidate.matched)
  const best = eligible[0]
  const runnerUp = eligible[1]

  if (!best) {
    return {
      ...row,
      matchedUserId: null,
      matchedUserName: null,
      confidence: candidates[0]?.confidence ?? 0,
      matchStatus: 'unmatched',
    }
  }
  if (runnerUp && best.confidence - runnerUp.confidence <= 0.05) {
    return {
      ...row,
      matchedUserId: null,
      matchedUserName: null,
      confidence: best.confidence,
      matchStatus: 'ambiguous',
    }
  }
  return {
    ...row,
    matchedUserId: best.member.id,
    matchedUserName: best.member.displayName,
    confidence: best.confidence,
    matchStatus: 'matched',
  }
}

export function matchFineRows(
  rows: readonly FinePreviewRow[],
  members: readonly FineImportMember[],
): FinePreviewRow[] {
  return rows.map((row) => matchFineRow(row, members))
}
